module.exports = "<router-outlet>\n        <block-ui>\n        </block-ui>\n</router-outlet>\n"